/*
 * @Author: liyxt
 * @Date: 2020-05-19 15:47:39
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 15:08:58
 * @Description: file content
 */
import React, { Component } from 'react';
//import OriginSlider from 'bee-slider';
import { Slider as OriginSlider } from "@tinper/next-ui";
//require('bee-slider/build/Slider.css');

class Slider extends Component {
    render() {
        let { tipFormatterSlider, ...other } = this.props;
        if (tipFormatterSlider !== undefined) {other.tipFormatter = other.tipFormatter || tipFormatterSlider;}
        return <OriginSlider {...other} />;
    }
}
//兼容一下
Slider.createSliderWithTooltip = component => component;

export default Slider;